import React, { useState, useEffect, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { EventBus } from "./eventBus";
import NavBar from "./NavBar";
import UserInfo from "./UserInfo";
import HomePage from "./pages/HomePage";
import * as utils from "./utils";

const OrderCancelPage = React.lazy(() => import("./pages/OrderCancelPage"));
const OrderModifyPage = React.lazy(() => import("./pages/OrderModifyPage"));
const OrderCheckPage = React.lazy(() => import("./pages/OrderCheckPage"));

const App: React.FC = () => {
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    const handleOrderCancelMessage = (data: any) => {
      if (data?.type === "cancel-order") {
        setMessages((prev) => [...prev, `取消订单: ${data.reason} (ID: ${data.reasonId})`]);
      } else {
        setMessages((prev) => [...prev, `订单取消: ${data}`]);
      }
    };
    const handleOrderModifyMessage = (data: any) => {
      if (data?.type === "modify-order") {
        setMessages((prev) => [...prev, `修改订单: ${data.modifyTypeLabel} - ${data.modifyValue}`]);
      } else if (data?.type === "modify-order-preview") {
        return;
      } else {
        setMessages((prev) => [...prev, `订单修改: ${data}`]);
      }
    };
    const handleOrderCheckMessage = (data: any) => {
      if (data?.type === "vehicle-inspection-confirm") {
        setMessages((prev) => [...prev, `验车确认: ${data.inspectionData.vehicleInfo.plateNumber} - ${data.inspectionData.inspector}`]);
      } else {
        setMessages((prev) => [...prev, `订单检查: ${data}`]);
      }
    };

    EventBus.on("order-cancel-message", handleOrderCancelMessage);
    EventBus.on("order-modify-message", handleOrderModifyMessage);
    EventBus.on("order-check-message", handleOrderCheckMessage);

    return () => {
      EventBus.off("order-cancel-message", handleOrderCancelMessage);
      EventBus.off("order-modify-message", handleOrderModifyMessage);
      EventBus.off("order-check-message", handleOrderCheckMessage);
    };
  }, []);

  useEffect(() => {
    utils.formatDate(new Date());
    utils.generateId();
    utils.debounce(() => {}, 100);
    utils.throttle(() => {}, 100);
    utils.truncateText("test", 10);
    utils.validateEmail("test@test.com");
    utils.validatePhone("13800138000");
    utils.deepClone({});
    utils.formatCurrency(100);
  }, []);

  return (
    <div style={{ padding: "20px", minHeight: "100vh" }}>
      <NavBar />
      <UserInfo />
      {messages.length > 0 && (
        <div className="glass-card" style={{ padding: "16px", marginBottom: "20px" }}>
          <div className="text-primary" style={{ marginBottom: "12px", marginTop: 0, marginLeft: 0, marginRight: 0, fontWeight: "600" }}>收到的消息:</div>
          {messages.map((msg, idx) => (
            <div key={idx} className="text-secondary" style={{ marginTop: "8px" }}>
              {msg}
            </div>
          ))}
        </div>
      )}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route 
          path="/order-cancel" 
          element={
            <Suspense fallback={<div className="text-secondary" style={{ padding: "12px", textAlign: "center" }}>加载订单取消页面中...</div>}>
              <OrderCancelPage />
            </Suspense>
          } 
        />
        <Route 
          path="/order-modify" 
          element={
            <Suspense fallback={<div className="text-secondary" style={{ padding: "12px", textAlign: "center" }}>加载订单修改页面中...</div>}>
              <OrderModifyPage />
            </Suspense>
          } 
        />
        <Route 
          path="/order-check" 
          element={
            <Suspense fallback={<div className="text-secondary" style={{ padding: "12px", textAlign: "center" }}>加载订单检查页面中...</div>}>
              <OrderCheckPage />
            </Suspense>
          } 
        />
      </Routes>
    </div>
  );
};

export default App;



